// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1666e52c","455":"d84a77af"}[chunkId] + ".chunk.js";
};